import { localDb } from "./db";

export class HttpError extends Error {
  constructor(readonly status: number) {
    super(`HTTP ${status}`);
    this.name = "HttpError";
  }
}

/** Nothing on the device yet, and no connection to fetch it. */
export class OfflineError extends Error {
  constructor() {
    super("Offline and not stored on this device.");
    this.name = "OfflineError";
  }
}

// A 5xx here is the proxy failing to reach the Api, which the waarnemer experiences as offline.
const unreachable = (error: unknown) =>
  error instanceof TypeError || (error instanceof HttpError && error.status >= 500);

/** Fetches and stores a copy on the device; without a connection it answers from that copy. */
export async function withDeviceCopy<T>(key: string, fetch: () => Promise<T>): Promise<T> {
  const db = await localDb();
  try {
    const fresh = await fetch();
    await db.put("cache", fresh, key);
    return fresh;
  } catch (error) {
    if (!unreachable(error)) throw error;
    const stored = await db.get("cache", key);
    if (stored === undefined) throw new OfflineError();
    return stored as T;
  }
}
